import React from 'react';
import { Typography, makeStyles, Card, CardContent, CardActions, GitHubIcon } from '@rbx/ui';
import { useTranslation } from '@rbx/intl';
import DynamicallyRouted from '@modules/miscellaneous/common/components/DynamicallyRouted';

const useScriptingLibrariesCardStyles = makeStyles<number>()((theme, hue) => ({
  buttonStyle: {
    flexGrow: 1,
  },
  cardStyle: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    background: `linear-gradient(135deg, hsl(${hue}deg 70% 50% / 25%), transparent 80%), ${theme.palette.surface[200]} !important`,
  },
}));

export interface ScriptingLibrariesCardProps {
  title: string;
  description: string;
  hue: number;
  packageHref: string;
  githubHref: string;
}

export default function ScriptingLibrariesCard({
  description,
  title,
  hue,
  packageHref,
  githubHref,
}: ScriptingLibrariesCardProps) {
  const {
    classes: { buttonStyle, cardStyle },
  } = useScriptingLibrariesCardStyles(hue);
  const { translate } = useTranslation();

  return (
    <Card classes={{ root: cardStyle }}>
      <CardContent>
        <Typography variant='h4' gutterBottom component='div'>
          {title}
        </Typography>
        <Typography>{description}</Typography>
      </CardContent>
      <CardActions>
        <DynamicallyRouted.Button
          size='small'
          variant='contained'
          classes={{ root: buttonStyle }}
          color='primary'
          href={packageHref}>
          {translate('Label.Marketplace')}
        </DynamicallyRouted.Button>
        <DynamicallyRouted.Button
          size='small'
          variant='outlined'
          color='primary'
          classes={{ root: buttonStyle }}
          startIcon={<GitHubIcon />}
          href={githubHref}>
          {translate('Label.Github')}
        </DynamicallyRouted.Button>
      </CardActions>
    </Card>
  );
}
